// Only register service worker in production, not in development
// This prevents refresh loops and caching issues during development
if ('serviceWorker' in navigator) {
  // Immediately unregister any existing service workers in development
  // This must happen BEFORE the page loads to prevent refresh loops
  const isDevelopment = process.env.NODE_ENV !== 'production'
  
  if (isDevelopment) {
    // Unregister immediately (don't wait for load event)
    (async () => {
      try {
        const registrations = await navigator.serviceWorker.getRegistrations()
        for (const registration of registrations) {
          const unregistered = await registration.unregister()
          if (unregistered) {
            console.log('[ServiceWorker] Unregistered service worker in development mode')
          }
        }
        // Also try to unregister by scope
        if (navigator.serviceWorker.controller) {
          navigator.serviceWorker.controller.postMessage({ type: 'SKIP_WAITING' })
        }
      } catch (error) {
        console.warn('[ServiceWorker] Error unregistering:', error)
      }
    })()
  } else {
    // Production: register service worker
    window.addEventListener('load', () => {
      navigator.serviceWorker.register('/service-worker.js').catch(() => {
        // Registration errors are non-fatal; skip to avoid console noise.
      })
    })
  }
}
